import { FC } from 'react';

interface Props {
   orientation?: 'horizontal' | 'vertical';
   color?: 'default' | 'primary' | 'secondary' | 'tertiary';
   selfStretch?: boolean;
}

export const Divider: FC<Props> = ({ orientation = 'horizontal', color = 'default', selfStretch = false }) => (
   <>
      {orientation === 'horizontal' && (
         <div data-testid={`divider--horizontal--${color}`} className="py-component-data-display-divider-container-spacing-padding-y-horizontal inline-flex w-full">
            <hr
               className={`
                        ${color === 'default' ? 'border-component-data-display-divider-line-color-fill-default' : ''}
                        ${color === 'primary' ? 'border-component-data-display-divider-line-color-fill-primary' : ''}
                        ${color === 'secondary' ? 'border-component-data-display-divider-line-color-fill-secondary' : ''}
                        ${color === 'tertiary' ? 'border-component-data-display-divider-line-color-fill-tertiary' : ''}
                        w-full border-t-component-data-display-divider-line-sizing-height-horizontal`.replace(/\s+/g, ' ')}
            />
         </div>
      )}

      {orientation === 'vertical' && (
         <div data-testid={`divider--vertical--${color}`} className={`px-component-data-display-divider-container-spacing-padding-x-vertical inline-flex ${selfStretch ? 'self-stretch' : 'h-full'}`}>
            <hr
               className={`${color === 'default' ? 'border-component-data-display-divider-line-color-fill-default' : ''}
                        ${color === 'primary' ? 'border-component-data-display-divider-line-color-fill-primary' : ''}
                        ${color === 'secondary' ? 'border-component-data-display-divider-line-color-fill-secondary' : ''}
                        ${color === 'tertiary' ? 'border-component-data-display-divider-line-color-fill-tertiary' : ''}
                         h-full border-t-0 border-r-component-data-display-divider-line-sizing-width-vertical`.replace(/\s+/g, ' ')}
            />
         </div>
      )}
   </>
);
